module.exports = __webpack_public_path__ + "img/AT0000002600615.28d76054.png";